import { render, staticRenderFns } from "./AddEditCampaign.vue?vue&type=template&id=18e83796&scoped=true&"
import script from "./AddEditCampaign.vue?vue&type=script&lang=js&"
export * from "./AddEditCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCampaign.vue?vue&type=style&index=0&id=18e83796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e83796",
  null
  
)

export default component.exports